import { z } from 'zod';

export const userSchema = z.object({
  id: z.number().int().positive(),
  login: z.string(),
  email: z.string().email(),
  displayName: z.string(),
  roles: z.array(z.string()).default([]),
  isSuperAdmin: z.boolean().optional(),
});

export type User = z.infer<typeof userSchema>;
